import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { buyModalShow, updateListingItems, setCollectionView } from "../../redux/marketplaceSlice";
import { toast } from "react-toastify";
import CategoryItemDetail from "./categoryItemDetail";
import CategoryItemDetaiListView from "./categoryItemDetaiListView";
import { getUserListings } from "../../utils/api";

const CategoryItem = ({ signingClient, allNfts, collections }) => {
  // console.log('all nfts = ', allNfts)
  const { sortedtrendingCategoryItemData, seiWallet, collectionView } =
    useSelector((state) => state.marketplace);
  const dispatch = useDispatch();

  const [limit, setLimit] = useState(0);
  const [listing, setListing] = useState([]);
  const [loading, setLoading] = useState(true);
  const [grid, setGrid] = useState(false);

  useEffect(() => {
    try {
      if (seiWallet) {
        const data = {
          user: seiWallet,
          subquery: limit,
        };
        getUserListings(data).then((data) => {
          console.log('data = ', data)
          dispatch(updateListingItems(data))
        });
      }
    } catch (error) {
      console.error("Error fetching collection listings:", error);
    }
  }, [seiWallet]);

  useEffect(() => {
    return () => {
      dispatch(setCollectionView(true))
    }
  }, [])

  return (
    <>
      {!collectionView ? (
        <>
          <div className="scrollbar-custom overflow-x-auto w-full">
            <div
              role="table"
              className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 lg:rounded-2lg w-full min-w-[736px] border bg-white text-sm dark:text-white"
            >
              <div
                className="dark:bg-jacarta-600 bg-jacarta-50 rounded-t-2lg flex"
                role="row"
              >
                <div className="w-[28%] py-3 px-4" role="columnheader">
                  <span className="text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis">
                    LISTED
                  </span>
                </div>
                <div className="w-[14%] py-3 px-4" role="columnheader">
                  <span className="text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis">
                    PRICE / MIN. BID
                  </span>
                </div>
                <div className="w-[14%] py-3 px-4" role="columnheader">
                  <span className="text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis">
                    TOP BID
                  </span>
                </div>
                <div className="w-[14%] py-3 px-4" role="columnheader">
                  <span className="text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis">
                    OWNER
                  </span>
                </div>
                <div className="w-[18%] py-3 px-4" role="columnheader">
                  <span className="text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis">
                    BUY / MAKE OFFER
                  </span>
                </div>
                <div className="w-[12%] py-3 px-4" role="columnheader">
                  <span className="text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis">
                    Owners
                  </span>
                </div>
              </div>
              {sortedtrendingCategoryItemData.map((item, index) => {
                const {
                  id,
                  token_id,
                  image,
                  title,
                  bidLimit,
                  bidCount,
                  contract,
                  likes,
                  creator,
                  owner,
                  collection,
                } = item;

                return (
                  <CategoryItemDetaiListView
                    key={index}
                    item={item}
                    listing={listing}
                    signingClient={signingClient}
                  />
                );
              })}
            </div>
          </div>
        </>
      ) : (
        <>
          {/* // <div className="grid grid-cols-1 gap-[1.875rem] md:grid-cols-2 lg:grid-cols-4"> */}
          <div className="flex flex-wrap w-full all_coll_nft_display overflow-x-auto">
            {allNfts && allNfts.length > 0 && allNfts.map((item, index) => {
              return (
                <CategoryItemDetail
                  key={index}
                  item={item}
                  signingClient={signingClient}
                  collections={collections}
                />
              );
            })}
          </div>
        </>
      )}
    </>
  );
};

export default CategoryItem;
